import accessControlEvents from '@features/access-control-events/locales/en';
import accessControlProfiles from '@features/access-control-profiles/locales/en';
import auth from '@features/auth/locales/en';
import billingGroups from '@features/billing-groups/locales/en';
import destinationGroups from '@features/destination-groups/locales/en';
import destinations from '@features/destinations/locales/en';
import hosts from '@features/hosts/locales/en';
import organizationAdmins from '@features/organization-admins/locales/en';
import settings from '@features/settings/locales/en';
import visits from '@features/visits/locales/en';

import common from './common.json';
import validation from './validation.json';

const resources = {
  common,
  validation,
  ...visits,
  ...accessControlEvents,
  ...accessControlProfiles,
  ...billingGroups,
  ...destinationGroups,
  ...destinations,
  ...organizationAdmins,
  ...settings,
  ...hosts,
  ...auth,
} as const;

export default resources;
